import { render, staticRenderFns } from "./TabelaSalarioMinimo.vue?vue&type=template&id=99acb112&scoped=true&"
import script from "./TabelaSalarioMinimo.vue?vue&type=script&lang=js&"
export * from "./TabelaSalarioMinimo.vue?vue&type=script&lang=js&"
import style0 from "./TabelaSalarioMinimo.vue?vue&type=style&index=0&id=99acb112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99acb112",
  null
  
)

export default component.exports